import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  intro?: ReactNode;
  theme?: 'navy' | 'light' | 'glass';
  align?: 'left' | 'center';
  className?: string;
}

export function SectionHeading({
  eyebrow,
  title,
  intro,
  theme = 'navy',
  align = 'left',
  className = '',
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';

  return (
    <Reveal className={`flex flex-col ${alignment} ${className}`}>
      {eyebrow && (
        <div className={`flex flex-col ${align === 'center' ? 'items-center' : 'items-start'} mb-4`}>
          <span className="ticca-grad-text mb-2 inline-block text-xs uppercase tracking-[0.18em] text-[#fcfcfc]">
            {eyebrow}
          </span>
          <motion.div
            className="h-0.5 rounded-full bg-gradient-to-r from-blue-400 to-cyan-400"
            initial={{ width: 0, opacity: 0 }}
            whileInView={{ width: 40, opacity: 1 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.6, delay: 0.15, ease: [0.25, 0.46, 0.45, 0.94] }}
          />
        </div>
      )}
      <h2 className={`text-balance ${align === 'center' ? 'max-w-3xl' : 'max-w-2xl'}`} style={{ color: '#4AAC00' }}>{title}</h2>
      {intro && <p className={`mt-4 max-w-xl ${theme === 'light' ? 'text-slate-600' : 'text-white/80'}`}>{intro}</p>}
    </Reveal>
  );
}
